/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CalculateLineItemsRequest} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'
import {CalculateLineItemsResponse} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'


export const calculateLineItems = (request: CalculateLineItemsRequest, options?: CashRequestOptions) => post<CalculateLineItemsRequest, CalculateLineItemsResponse>("/cash-app/local/calculate-line-items", request, {...options, rejectOnError: true })